<template>
  <validation-observer
    v-slot="propertyMaindorLockObserver"
    slim
  >
    <form-section
      id="property-maindor-lock"
      v-bind="propertyMaindorLockObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="What kind of lock is fitted to your main external door?"
        :error="formObserver.validated && !propertyMaindorLockObserver.valid"
      >
        <validation-provider
          v-slot="{ failed, failedRules }"
          name="Property Maindor Lock"
          :vid="`${stepId}_property-maindor-lock`"
          rules="required"
          slim
        >
          <radio
            v-model="questionData.propertyMaindorLock"
            name="property-main-door-lock-type"
            class="property-lock-type"
            column
            wide
            :error="failed"
            :error-messages="getFieldErrors('propertyMaindorLock', failedRules)"
            :items="propertyMaindorLockItems"
            :data-test="snakeCase(questionFields.propertyMaindorLock)"
          />
        </validation-provider>

        <template
          v-if="!questionData.propertyMaindorLock"
          slot="helpText"
        >
          <component
            :is="isExperimentMinimiseHelptext ? 'show-more' : 'div'"
            open-text="Selecting Primary Lock Type"
            hide-text="Selecting Primary Lock Type"
          >
            <p>Please select a lock type to see a description here.</p>
            <p>
              You may have other mechanisms for locking your door in addition to the main lock, such as latches or door chains, guards and bolts.
              These are often secondary locks. We only need to know about the primary lock that gives your home the most protection from intruders.
            </p>
          </component>
        </template>

        <template v-for="(lock, index) in propertyMaindorLockItems">
          <p
            v-if="questionData.propertyMaindorLock === lock.value"
            slot="helpText"
            :key="index"
          >
            <strong>{{ lock.text }}</strong><br>
            {{ lock.description }}
          </p>
        </template>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

export default {
  name: 'question-property-maindor-lock',
  extends: QuestionBase,
  props: {
    withOtherIcon: {
      type: Boolean,
      default: false,
    },
    isExperimentMinimiseHelptext: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      fields: ['propertyMaindorLock'],
    };
  },
  computed: {
    propertyMaindorLockItems () {
      return this.helpers.createLocksOptions(
        this.constants.HOME_PROPERTY_MAINDOR_LOCK,
        this.config,
        this.constants.LOCK_ANIMATIONS,
        this.withOtherIcon,
      );
    },
  },
};
</script>
